<template>
  <div class="loan_item">
    <div class="inner">
      <h3>About Us</h3>
      <!-- <h3>关于我们</h3> -->
      <div class="left_cell">
        <p>JAWABU CREDIT limited (herein after JAWABU) was incorporated on 21st of May, 2021 as a credit only/Non deposit taking micro finance. The company was issued with a letter of no objection from the central bank of Kenya dated 7th of May, 2021.  </p>
        <p>The company was incorporated with the aim of having its area of operations being within the Republic of Kenya with a main clientele being the local Kenyan citizen. The aim of JAWABU is to create a more reliable user-friendly lending platform for the cast and diverse population of Kenya.</p>
      </div>
      <div class="right_cell">
        <img src="@/assets/images/loanImg/bn_n.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.loan_item{
  .inner{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    h3{
      font-size: 36px;
      color: #333333;
    }
    .left_cell{
      float: left;
      width: 50%;
      padding: 60px 0;
      p{
        font-size: 16px;
        line-height: 30px;
        color: #999999;
      }
      ul{
        padding-top: 60px;
        li{
          float: left;
          width: 188px;
          height: 132px;
          padding-top: 50px;
          text-align: center;
          font-size: 16px;
          border-radius: 4px;
          border: 1px solid #f1f1f1;
          color: #333333;
          box-shadow: 0px 1px 10px 1px #f1f1f1;
          margin-right: 40px;
          margin-left: 5px;
        }
      }

    }
    .right_cell{
      float: left;
      width: 50%;
      padding: 60px 0;
      img{
        width: 560px;
      }

    }
  }

}
</style>
